import { useWeb3React } from '@web3-react/core'
import BigNumber from 'bignumber.js'
import useRefresh from 'hooks/useRefresh'
import { useEffect, useState } from 'react'
import { getVvsBoostContract } from 'utils/contractHelpers'

const vvsBoostContract = getVvsBoostContract()

export default function useBoostEarnings() {
  const { account } = useWeb3React()
  const { slowRefresh } = useRefresh()
  const [earningSum, setEarningsSum] = useState<number>(null)

  useEffect(() => {
    const fetchBoostPendingVVS = async () => {
      const pendingVVS = await vvsBoostContract.pendingVVS(account)
      setEarningsSum(new BigNumber(pendingVVS._hex).toNumber())
    }

    if (account) {
      fetchBoostPendingVVS()
    }
  }, [slowRefresh, account])

  return earningSum
}
